module.exports = __webpack_public_path__ + "img/left-arrow.583e9e23.svg";